// extracted by mini-css-extract-plugin
export default {"contactsSection":"map_section_contactsSection__MK57j"};